import { trackEvent } from "../trackEvent";

export const parseProductDataObj = (target, selector = "[data-obj-data]") => {
	const rawData = target.closest(selector)?.getAttribute("data-obj-data");
  
	try {
		return rawData ? JSON.parse(rawData) : {};
	} catch {
		console.warn("Invalid product data", rawData);
		return {};
	}
};

export const pushSelectItem = ({ index, item_category, item_id, item_name }) => 
	trackEvent({
		event: "select_item",
		event_type: "click",
		ecommerce: {
			items: [{ 
				index, 
				item_category, 
				item_id, 
				item_name, 
				origin: window.location.pathname 
			}],
		},
});